// this file holds the project class
import { JmApi } from "../jm-api/jm-api";
import { DataInstance } from "./data-instance";

export class Project extends DataInstance {
  public static BASE_URL: string =
    import.meta.env.VITE_CLEVERREACH_API_BASE_URL + "/jmapi/v1/projects";

  private data: { name: string | undefined; id: number | undefined };

  constructor(name: string | undefined, id: number | undefined) {
    super();
    this.data = {
      name: name,
      id: id,
    };
  }

  get currentId(): number | undefined {
    return this.id;
  }

  set currentId(id: number | undefined) {
    this.id = id;
  }

  get currentData(): { name: string | undefined } {
    return this.data;
  }

  static deleteUrlBuilder(id: number) {
    return `${Project.BASE_URL}?projId=${id}`;
  }

  static getUrlBuilder() {
    console.log("getUrlBuilder was called in project.ts");

    return Project.BASE_URL;
  }

  static postUrlBuilder() {
    return Project.BASE_URL;
  }

  static putUrlBuilder() {
    return Project.BASE_URL;
  }

  async post(chain: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
      JmApi.post(Project.BASE_URL, this.data).then((data: object) => {
        if (data["id"]) {
          this.id = data["id"];
          if (chain) {
            console.log("Projekt erfolgreich hinzugefügt.");

            resolve("Projekt erfolgreich hinzugefügt");
          }
        } else {
          if (chain) {
            reject(data);
          }
        }
      });
    });
  }

  static fromObject(o: object): Project | null {
    if (o["name"]) {
      const result: Project = new Project(o["name"]);
      if (!o["id"]) {
        return result;
      } else {
        result.id = o["id"];
        return result;
      }
    } else {
      return null;
    }
  }
}
